/**
 * ---------------------------------------------------------------------------
 * Bellavista — productgalerij: thumbnails links, één grote foto
 * ---------------------------------------------------------------------------
 * Op desktop (vanaf 1008 px):
 *   - de strip met productfoto's staat als een smalle verticale kolom links
 *     van de hoofdafbeelding, in plaats van eronder;
 *   - in het grote vlak staat één foto in plaats van een rij foto's naast
 *     elkaar. Klikken op een thumbnail zet die foto groot.
 * Op mobiel verandert er niets aan de plaats van de strip: die blijft onder
 * de foto staan.
 *
 * Extra: het thema koppelt de thumbnails niet altijd aan de hoofdcarousel
 * (afhankelijk van de volgorde waarin Swiper opstart bleef klikken op een
 * thumbnail soms zonder gevolg). Dit script legt die koppeling zelf, en
 * regelt het klikken hoe dan ook zelf via de mediapositie van de foto.
 *
 * Opmaak: assets/custom.css (klasse bv-thumbsLeft).
 * Geladen vanuit snippets/product-gallery.liquid.
 * ---------------------------------------------------------------------------
 */
(function () {
  'use strict';

  if (window.__bvThumbsLeft) return;
  window.__bvThumbsLeft = true;

  var DESKTOP = '(min-width: 1008px)';
  var CLASS = 'bv-thumbsLeft';
  var mq = window.matchMedia(DESKTOP);
  var tries = 0;

  function galleries() {
    return Array.prototype.slice.call(
      document.querySelectorAll('.ProductDesign .ProductGallery--carousel')
    );
  }

  function items(element) {
    return Array.prototype.slice.call(element.querySelectorAll('.Carousel__Item'));
  }

  function update(element) {
    if (!element || !element.swiper || element.swiper.animating) return;
    try {
      element.swiper.update();
      element.swiper.slideTo(element.swiper.activeIndex, 0);
    } catch (error) { /* niets aan te doen */ }
  }

  // De kolom is precies even hoog als de hoofdafbeelding ernaast.
  function fitHeight(gallery) {
    var thumbs = gallery.querySelector('.ProductGallery__Thumbs');
    var main = gallery.querySelector('.ProductGallery__Carousel');
    if (!thumbs || !main) return;

    if (!mq.matches) {
      if (thumbs.style.height) thumbs.style.height = '';
      return;
    }

    var height = Math.round(main.getBoundingClientRect().height);
    if (height < 80) return;
    if (thumbs.style.height === height + 'px') return;

    thumbs.style.height = height + 'px';
    if (thumbs.swiper) {
      try { thumbs.swiper.update(); } catch (error) { /* niets aan te doen */ }
    }
  }

  // De stylesheet en de foto's zijn niet altijd binnen op het moment dat dit
  // script draait, dus even nameten zolang de pagina nog aan het laden is.
  function settle(gallery) {
    var main = gallery.querySelector('.ProductGallery__Carousel');

    [0, 150, 400, 1000, 2500].forEach(function (delay) {
      setTimeout(function () {
        if (delay <= 400) update(main);
        fitHeight(gallery);
      }, delay);
    });

    if (document.readyState !== 'complete') {
      window.addEventListener('load', function () {
        update(main);
        fitHeight(gallery);
      }, { once: true });
    }
  }

  function watch(gallery, main) {
    if (gallery.__bvWatched || typeof ResizeObserver === 'undefined') return;
    gallery.__bvWatched = true;
    new ResizeObserver(function () {
      fitHeight(gallery);
    }).observe(main);
  }

  // Muiswiel scrollt de thumbnailkolom; bovenaan en onderaan krijgt de pagina
  // de scroll gewoon terug (releaseOnEdges).
  function wheel(swiper, on) {
    try {
      if (!swiper.mousewheel) return;
      if (!on) {
        if (swiper.mousewheel.enabled) swiper.mousewheel.disable();
        return;
      }
      var settings = swiper.params.mousewheel || {};
      settings.enabled = true;
      settings.forceToAxis = true;
      settings.releaseOnEdges = true;
      if (!settings.eventsTarget) settings.eventsTarget = 'container';
      swiper.params.mousewheel = settings;
      if (!swiper.mousewheel.enabled) swiper.mousewheel.enable();
    } catch (error) { /* niets aan te doen */ }
  }

  // Zorgt dat de galerij weet welke thumbnail actief is (rand + meescrollen).
  function link(main, thumbs) {
    try {
      var swiper = main.swiper;
      if (!swiper.thumbs || !thumbs.swiper) return;
      if (swiper.thumbs.swiper === thumbs.swiper) return;
      swiper.thumbs.swiper = thumbs.swiper;
      if (swiper.params.thumbs) swiper.params.thumbs.swiper = thumbs.swiper;
      if (swiper.thumbs.update) swiper.thumbs.update(true);
    } catch (error) { /* niets aan te doen */ }
  }

  // Welke foto hoort bij deze thumbnail? In loop-modus schuift Swiper de
  // slides door elkaar, dus zoeken we op de mediapositie in plaats van op de
  // plaats in de DOM.
  function mediaIndex(thumbs, item) {
    var attribute = item.getAttribute('data-swiper-slide-index');
    if (attribute !== null && attribute !== '') {
      var parsed = parseInt(attribute, 10);
      if (!isNaN(parsed)) return parsed;
    }
    return items(thumbs).indexOf(item);
  }

  function bindClicks(gallery, thumbs, main) {
    if (gallery.__bvClicks) return;
    gallery.__bvClicks = true;

    thumbs.addEventListener('click', function (event) {
      if (!main.swiper) return;
      var item = event.target && event.target.closest ? event.target.closest('.Carousel__Item') : null;
      if (!item) return;

      var index = mediaIndex(thumbs, item);
      if (index < 0) return;

      var slides = Array.prototype.slice.call(main.swiper.slides);
      var target = -1;
      for (var i = 0; i < slides.length; i++) {
        if (slides[i].getAttribute('data-media-position') === String(index + 1)) {
          target = i;
          break;
        }
      }
      try { main.swiper.slideTo(target < 0 ? index : target); } catch (error) { /* niets aan te doen */ }
    });
  }

  function apply(gallery) {
    var thumbs = gallery.querySelector('.ProductGallery__Thumbs');
    var main = gallery.querySelector('.ProductGallery__Carousel');

    if (!main || !main.swiper) return false;

    // Producten met één foto hebben geen thumbnailstrip.
    if (thumbs && !thumbs.swiper) return false;

    if (thumbs) {
      link(main, thumbs);
      bindClicks(gallery, thumbs, main);
    }

    if (mq.matches) {
      gallery.classList.add(CLASS);

      if (thumbs) {
        var swiper = thumbs.swiper;

        // Loop uit: in loop-modus verplaatst Swiper de thumbnails in de DOM
        // zodra je door de galerij bladert, en dan klopt de volgorde in de
        // kolom niet meer.
        if (swiper.params.loop) {
          swiper.params.loop = false;
          try { swiper.loopDestroy(); } catch (error) { /* niets aan te doen */ }
        }
        if (swiper.params.direction !== 'vertical') {
          try { swiper.changeDirection('vertical'); } catch (error) { /* niets aan te doen */ }
        }
        wheel(swiper, true);
      }

      settle(gallery);
    } else {
      gallery.classList.remove(CLASS);

      if (thumbs) {
        if (thumbs.style.height) thumbs.style.height = '';
        if (thumbs.swiper.params.direction !== 'horizontal') {
          try { thumbs.swiper.changeDirection('horizontal'); } catch (error) { /* niets aan te doen */ }
        }
        wheel(thumbs.swiper, false);
        update(thumbs);
      }
      update(main);
    }

    watch(gallery, main);
    return true;
  }

  function run() {
    var list = galleries();
    var ready = 0;
    list.forEach(function (gallery) {
      if (apply(gallery)) ready++;
    });
    return list.length === ready;
  }

  // Swiper start pas op nadat theme.js geladen is, vandaar het kort herproberen.
  function start() {
    if (run()) return;
    if (tries >= 40) return;
    tries++;
    setTimeout(start, 150);
  }

  function restart() {
    tries = 0;
    start();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  if (mq.addEventListener) {
    mq.addEventListener('change', restart);
  } else if (mq.addListener) {
    mq.addListener(restart);
  }

  window.addEventListener('resize', function () {
    galleries().forEach(fitHeight);
  });

  document.addEventListener('shopify:section:load', function () {
    setTimeout(restart, 100);
  });
})();
